import { styled } from "@mui/material";

export default styled("div")(
    ({ theme }) => `

    .center {
        width: 100%;
        margin:0 auto;
        .paper {
            padding: ${theme.spacing(2)};
        }
    }
`
);
